import { axiosInstance as request } from '@api/rest.service'

/**
 * @description GET /{entity}/{id}/files/additional-orders
 * @returns {AxiosPromise<any>}
 */
export const GET_ADDITIONAL_ORDERS_FOR_ENTITY = (entity, id) => {
  return request.get(`${entity}/${id}/files/additional-orders`)
}

/**
 * @description GET /{entity}/{id}/files/additional-invoices
 * @returns {AxiosPromise<any>}
 */
export const GET_ADDITIONAL_INVOICES_FOR_ENTITY = (entity, id) => {
  return request.get(`${entity}/${id}/files/additional-invoices`)
}

/**
 * @description GET /{entity}/{id}/files/additional-invoices
 * @returns {AxiosPromise<any>}
 */
export const GET_ENTITY_ADDITIONAL_INVOICES = (entity, id) => {
  return request.get(`${entity}/${id}/files/additional-invoices`)
}

/**
 * @description PUT /{entity}/${id}/files/additional-orders/{orderId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_ENTITY_ADDITIONAL_ORDER = (entity, id, orderId, payload) => {
  return request.put(`${entity}/${id}/files/additional-orders/${orderId}`, payload)
}

/**
 * @description PUT /{entity}/{id}/files/additional-invoices/{invoiceId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_ENTITY_ADDITIONAL_INVOICE = (entity, id, invoiceId, payload) => {
  return request.put(`${entity}/${id}/files/additional-invoices/${invoiceId}`, payload)
}

/**
 * @description DELETE /{entity}/{id}/files/additional-orders/{orderId}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_ENTITY_ADDITIONAL_ORDER = (entity, id, orderId) => {
  return request.delete(`${entity}/${id}/files/additional-orders/${orderId}`)
}

/**
 * @description DELETE /subscriptions/${subId}/files/additional-invoices/${id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_SUBSCRIPTION_ADDITIONAL_INVOICE = (subId, orderId) => {
  return request.delete(`subscriptions/${subId}/files/additional-invoices/${orderId}`)
}

/**
 * @description POST /${entity}/${id}/files/additional-orders
 * @returns {AxiosPromise<any>}
 */
export const CREATE_ADDITIONAL_ORDER_FOR_ENTITY = (entity, id, payload) => {
  return request.post(`${entity}/${id}/files/additional-orders`, payload)
}

/**
 * @description POST /${entity}/${id}/files/additional-invoices
 * @returns {AxiosPromise<any>}
 */
export const CREATE_ADDITIONAL_INVOICE_FOR_ENTITY = (entity, id, payload) => {
  return request.post(`${entity}/${id}/files/additional-invoices`, payload)
}
